import type { NuxtApp } from '#app/nuxt';
import { onConsentStudioScan } from '../consent-studio';
import { loadScript } from '../dom/loadScript';

export async function initGtag(nuxt: NuxtApp): Promise<boolean> {
    if (typeof window === 'undefined') return false;
    console.log('[Gtag]: Init.');

    const ADS_ID = 'AW-1016583416';

    window.dataLayer = window.dataLayer || [];
    const gtag = window.gtag = window.gtag || function () {
        window.dataLayer.push(arguments);
    };

    onConsentStudioScan(() => {
        // Don't touch: set all consent signals to granted for the Consent Studio cookie scanner
        gtag('consent', 'default', {
            ad_storage: 'granted',
            ad_user_data: 'granted',
            ad_personalization: 'granted',
            analytics_storage: 'granted',
            functionality_storage: 'granted',
            personalization_storage: 'granted',
            security_storage: 'granted',
            wait_for_update: 500
        });
    }, () => {
        gtag("consent", "default", {
            ad_storage: "denied",
            ad_user_data: "denied",
            ad_personalization: "denied",
            analytics_storage: "denied",
            functionality_storage: "granted",
            personalization_storage: "granted",
            security_storage: "granted",
            wait_for_update: 500,
        });
    });

    // Set a value for ads data redaction
    // More information: https://support.google.com/analytics/answer/13544947?hl=en
    gtag('set', 'ads_data_redaction', true);
    // Set the Consent Studio developer ID
    gtag('set', 'developer_id.dZTlmZj', true);

    gtag('js', new Date());

    await loadScript(`https://www.googletagmanager.com/gtag/js?id=${ADS_ID}`, {
        async: false,
        defer: true
    });

    gtag('config', ADS_ID);

    return true;
};